import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
//import logo from 'assets/spedmeyer-high-resolution-logo.png';
//import logo1 from 'assets/spedmeyer-high-resolution-logo-grayscale.png';
//import logo2 from 'assets/spedmeyer-high-resolution-logo-grayscale-transparent.png';
import logo3 from 'assets/spedmeyer-high-resolution-logo-transparent.png';

export const Logo = ({ to }) => {

  if (!to) {
    return (
      <StyledImg src={logo3} />
    );
  }

  return (
    <Link to={to}>
      <StyledImg src={logo3} />
    </Link>
  );
};


const StyledImg = styled.img`
//  display: block;
  max-width:150px;
//  width: auto;
//  height: auto;
`;
